
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc/[categorySlug]/[seoSlug]/[slug]",
      function () {
        return require("private-next-pages/tin-tuc/[categorySlug]/[seoSlug]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tin-tuc/[categorySlug]/[seoSlug]/[slug]"])
      });
    }
  